import { render, staticRenderFns } from "./_create-support-ticket.vue?vue&type=template&id=ee66b42a"
import script from "./_create-support-ticket.vue?vue&type=script&lang=js"
export * from "./_create-support-ticket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports